import { useLocation } from 'react-router-dom';
import Footer from './Footer';

const FooterToggle = () => {
    const location = useLocation();

    const showFooter = !['/account/profile', '/account/subscription', '/account/settings', '/account/admin', '/account/applications'].includes(location.pathname);

    return showFooter ? <Footer /> : null;
};

export default FooterToggle;